import { FormikProps } from 'formik';
import t from 'utils/translationHelper';
import * as yup from 'yup';

import { BeneficiaryDto } from '@alpha/bene-dtos';
import {
  DrawdownFundingMethod,
  DrawdownRequest,
  DrawdownSubmissionRequest,
} from '@alpha/fx-dtos';
import { PaymentOnlineOrigin, PaymentPurposeDto } from '@alpha/payments-dtos';

import {
  FormikDrawdownPaymentType,
  FormikPaymentType,
} from '../../Payments/CreatePaymentDrawer/formData';

export const initialValues: DrawdownRequest = {
  tradeId: '',
  fixCurrencyCode: '',
  valueDate: '',
  amount: 0,
  fundingMethod: DrawdownFundingMethod.CURRENCY_ACCOUNT_BALANCE,
  sellCurrencyCode: '',
  buyCurrencyCode: '',
  rate: 0,
};

export type FirstPartyDrawdownType = {
  fixCurrencyCode: string;
  amount: number;
  valueDate: string;
  fundingMethod: DrawdownFundingMethod;
  sellCurrencyCode: string;
  buyCurrencyCode: string;
  rate: number;
  id: string;
  beneficiary?: BeneficiaryDto;
  date?: string;
  purpose?: string;
  reference?: string;
  emailAddresses: string[];
  singlePayment: boolean;
  paymentOrigin: PaymentOnlineOrigin;
  tradeId?: string; // For adding payment AFTER booking Trade
  payments: FormikPaymentType[];
  purposeType?: string;
  invoiceNumber?: string;
  invoiceDate?: string;
};

export const firstPartyDrawdownInitialValues: FirstPartyDrawdownType = {
  tradeId: '',
  fixCurrencyCode: '',
  valueDate: '',
  amount: 0,
  fundingMethod: DrawdownFundingMethod.WIRE_TRANSFER,
  sellCurrencyCode: '',
  buyCurrencyCode: '',
  rate: 0,
  payments: [],
  invoiceNumber: '',
  invoiceDate: undefined,
  id: '',
  emailAddresses: [],
  singlePayment: false,
  paymentOrigin: PaymentOnlineOrigin.DRAWDOWN,
  purpose: undefined,
  purposeType: undefined,
  reference: '',
};

export const drawdownSubmissionInitialValues: DrawdownSubmissionRequest = {
  paymentIds: [],
  dynamicLinkingId: '',
};

export const paymentsInitialValues: FormikType = {
  payments: [],
};

export type FormikValueProps = FormikProps<FormikType>;
export type FormikType = {
  payments?: FormikPaymentType[];
};

const replaceCommaSeperator = (o: string, v: string) => parseFloat(v ? v.replace(/,/g, '') : '');

export const validation = {
  amount: yup
    .number()
    .transform(replaceCommaSeperator)
    .typeError(t('please_enter_numbers_only'))
    .required(t('please_enter_a_valid_amount'))
    .positive(t('please_enter_a_positive_amount')),
  fixCurrencyCode: yup.string().required(t('please_select_a_currency')),
  valueDate: yup.string().required(t('please_specify_a_value_date')),
  invoiceNumber: yup.string().when('purposeType', {
    is: 'Service',
    then: yup.string().required(t('invoice_number_is_a_required_field'))
      .matches(/^[A-Za-z0-9.,?/:()+‘’' -]*$/, t('special_characters_are_not_allowed')),
  }).nullable(),
  invoiceDate: yup.string().when('purposeType', {
    is: 'Service',
    then: yup.string().required(t('invoice_date_required_for_purpose_code_service')),
  }).nullable(),
  reference: yup.string().nullable()
    .matches(/^[A-Za-z0-9.,?/:()+‘’' -]*$/, t('special_characters_are_not_allowed'))
    .test('len', t('must_be_140_characters_or_less'), (val) => {
      if (!val) return true;
      return val?.length <= 140;
  }),
};

export const submissionformValidation = {
  paymentIds: yup.array().typeError(t('please_enter_an_id_array')),
};

export default validation;
